import React, { useState } from 'react';
import { Radio } from 'semantic-ui-react';
import styled from "styled-components";
const StyledRadio = styled(Radio) `
  margin-right: 3px;
`;
const RadioGroup = ({ options, onSelect }) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const handleChange = (event, { value }) => {
        setSelectedValue(value);
        onSelect(value);
    };
    return React.createElement("div", { className: "flex flex-wrap gap-2" }, options.map(option => (React.createElement(StyledRadio, { className: "f-bg-opaque border-gray-300 cursor-pointer border py-2 px-3 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500", label: option.text, name: 'radioGroup', value: option.value, checked: selectedValue === option.value, onChange: handleChange }))));
};
export default RadioGroup;
